import styled from 'styled-components'

import Col from '@components/atoms/Grid/Col'

export const Root = styled.div``

export const StyledCol = styled(Col)`
  margin-bottom: ${(props) => props.theme.margin.big};
`
